import { linkAcessivel } from "./supabase";
// Impressão dos PDFs (DANFE simplificado e etiqueta) a partir de links temporários.
// Baixa o arquivo, abre num iframe da própria página e chama a impressão.
// Na bancada, abra o Chrome com --kiosk-printing para imprimir direto na
// impressora padrão, sem a janela de confirmação.

/** Imprime o PDF. Devolve false se nem a impressão nem a aba abriram (pop-up bloqueado). */
export async function imprimirPdf(link: string): Promise<boolean> {
  const url = linkAcessivel(link);
  let blobUrl: string | null = null;
  try {
    const resposta = await fetch(url);
    if (!resposta.ok) throw new Error(`HTTP ${resposta.status}`);
    const blob = await resposta.blob();
    blobUrl = URL.createObjectURL(blob);
  } catch {
    // sem CORS (link externo da transportadora): abre numa aba para imprimir à mão
    return window.open(url, "_blank") !== null;
  }

  await new Promise<void>((resolve) => {
    const frame = document.createElement("iframe");
    frame.style.position = "fixed";
    frame.style.right = "0";
    frame.style.bottom = "0";
    frame.style.width = "1px";
    frame.style.height = "1px";
    frame.style.border = "0";
    frame.src = blobUrl!;
    frame.onload = () => {
      setTimeout(() => {
        try {
          frame.contentWindow?.focus();
          frame.contentWindow?.print();
        } catch {
          window.open(blobUrl!, "_blank", "noopener");
        }
        // dá tempo da fila de impressão pegar o arquivo antes de limpar
        setTimeout(() => {
          frame.remove();
          URL.revokeObjectURL(blobUrl!);
        }, 60_000);
        resolve();
      }, 300);
    };
    document.body.appendChild(frame);
  });
  return true;
}
